var _rect, _rect2, _rect3, _rect4, _rect5, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34.813,
    width: 44,
    height: 29,
    rx: 2,
    transform: "rotate(-12.8865 21 34.813)",
    fill: "#D2D2D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5938,
    y: 37.0684,
    width: 38,
    height: 23,
    rx: 1,
    transform: "rotate(-12.8865 24.5938 37.0684)",
    fill: "#F8F8F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34.813,
    width: 44,
    height: 29,
    rx: 2,
    transform: "rotate(-12.8865 21 34.813)",
    fill: "url(#paint0_linear_8260_132383)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 41,
    width: 44,
    height: 33,
    rx: 2,
    fill: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 63.5986V45C36 44.4477 36.4477 44 37 44H73C73.5523 44 74 44.4477 74 45V56.8416C74 57.7681 72.8488 58.1964 72.2432 57.4952L64.6546 48.7084C64.2711 48.2644 63.5894 48.2444 63.1806 48.6652L49.5702 62.6736C49.1774 63.0778 48.5284 63.0778 48.1357 62.6736L44.5278 58.9602C44.1401 58.5611 43.5011 58.5553 43.1062 58.9473L37.7044 64.3084C37.0734 64.9347 36 64.4877 36 63.5986Z",
    fill: "#F8F8F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 50,
    r: 3,
    fill: "#D2D2D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8260_132383",
    x1: 44.933,
    y1: 69.2037,
    x2: 43.3664,
    y2: 33.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/Noimage.fab7ed10d606ee776ed12d8524df5a02.svg";
export { ForwardRef as ReactComponent };